/**
 * @generated SignedSource<<684d6efbcb8787f95239cdcbfc643175>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentItemRenderContent$data = {
  readonly __typename: "Video";
  readonly " $fragmentSpreads": FragmentRefs<"cardContentItemContent" | "contentActionBarContent" | "contentAuthorImageContent" | "contentAuthorLinkContent" | "contentCoverImageContent" | "contentCoverVideoContent" | "contentHeadlineContent" | "contentLiveTagContent" | "contentPrintHeadlineContent" | "contentPublishedDateContent" | "contentSectionsContent" | "contentSubHeadlineContent" | "contentSummaryContent" | "contentTopicLinkContent" | "entityLink" | "homeAdvertiserContentItemContent" | "homeAroundMorningStudioPrimaryContentItemContent" | "homeAroundMorningStudioSecondaryContentItemContent" | "homeAroundPrimaryContentItemContent" | "homeAroundSecondaryContentItemContent" | "homeCommentContentItemContent" | "homeDailyFiveContentItemContent" | "homeFocusContentItemContent" | "homeHarryContentItemContent" | "homeHeroArticleContentItemContent" | "homeLatestContentItemContent" | "homeMultimediaContentItemContent" | "homeMultimediaPodcastContentItemContent" | "homePrimaryContentItemContent" | "homeSecondaryContentItemContent" | "homeSectionLeadPrimaryContentItemContent" | "homeSectionLeadSecondaryContentItemContent" | "homeStoryPackageLeadContentItemContent" | "homeStoryPackageTailContentItemContent" | "homeSuperSplashLargePrimaryContentItemContent" | "homeSuperSplashLivePrimaryContentItemContent" | "homeSuperSplashLiveSecondaryContentItemContent" | "hooksUseContentSponsorContent" | "magazinesStyleArticleMoreOnThisContentItemContent" | "magazinesStyleCardContentItemContent" | "magazinesStyleFashionCarouselContentItemContent" | "magazinesStyleLeadContentItemContent" | "magazinesStyleSpotlightContentItemContent" | "morningStudioContentItemContent" | "opinionContentItemContent" | "postiesPrimaryContentItemContent" | "postiesSecondaryContentItemContent" | "postiesSectionPrimaryContentItemContent" | "postiesSectionSecondaryContentItemContent" | "primaryContentItemContent" | "searchContentItemContent" | "secondaryContentItemContent" | "videoDurationOverlayVideo">;
  readonly " $fragmentType": "contentItemRenderContent";
};
export type contentItemRenderContent$key = {
  readonly " $data"?: contentItemRenderContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentItemRenderContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentItemRenderContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverImageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentActionBarContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentCoverVideoContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentPublishedDateContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSubHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSummaryContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentPrintHeadlineContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentTopicLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentLiveTagContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentAuthorLinkContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentAuthorImageContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "primaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "secondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "searchContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "opinionContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "cardContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "morningStudioContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleLeadContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleCardContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleArticleMoreOnThisContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksUseContentSponsorContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesSectionPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "postiesSectionSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeAdvertiserContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeAroundMorningStudioPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeAroundMorningStudioSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeAroundPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeAroundSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeDailyFiveContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeMultimediaContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeMultimediaPodcastContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeFocusContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homePrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSectionLeadPrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSectionLeadSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSuperSplashLargePrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSuperSplashLivePrimaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeSuperSplashLiveSecondaryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeHarryContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeLatestContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeCommentContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeStoryPackageLeadContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeStoryPackageTailContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSectionsContent"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "videoDurationOverlayVideo"
        }
      ],
      "type": "Video",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleFashionCarouselContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "magazinesStyleSpotlightContentItemContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "homeHeroArticleContentItemContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "c4e9f279d678a8129fada6ab59fdf568";

export default node;
